import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { useEffect, useState, useRef } from "react";
import { Button } from "../../../../../../shadcn/components/ui/button";

export const LocationHubRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const options = uischema?.options?.additionalData || {};

  const [locationList, setLocationList] = useState([]);
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);

  const handleClick = (item: any) => {
    handleChange(path, item);
  };

  useEffect(() => {
    setLocationList(options[ctx?.core?.data?.subPropertyType?.value]);
  }, [ctx?.core?.data?.subPropertyType]);

  const width = uischema?.options?.width;
  const show = uischema?.options?.show;

  useEffect(() => {
    if (show === false || locationList?.length === 0) {
      handleChange(path, {});
    }
  }, [show, locationList]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
        return;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return (
    <>
      {locationList?.length > 0 ? (
        <div ref={positionRef} className="mt-[62px]">
          <p className="font-openSans font-semibold text-web-subheading leading-4 text-brand-bgBlack uppercase">
            {schema?.title}
          </p>
          <div className="flex flex-wrap gap-7 mt-5">
            {locationList?.map((item: any, index) => (
              <Button
                className={`text-brand-bgBlack relative rounded-full border hover:bg-brand-lightOrange px-9 ${
                  width ? width : "w-fit"
                }  ${
                  data?.value === item?.value
                    ? "bg-brand-lightOrange"
                    : "bg-white"
                }`}
                key={item?.value}
                onClick={() => handleClick(item)}
              >
                {item?.title}
              </Button>
            ))}
          </div>{" "}
          {customError && (
            <label
              htmlFor="name"
              className={"text-brand-textRed text-web-body-sm ml-2"}
            >
              {customError}
            </label>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default withJsonFormsControlProps(LocationHubRenderer);
